import { useState, useEffect } from 'react';
import { X, Trash2, Plus, Check, Mail, MessageCircle, AlertTriangle } from 'lucide-react';
import { gmailAccountsAPI, smsAPI } from '../api';
import './AutoTaskLogs.css';

function GmailAccounts({ onClose }) {
  const [accounts, setAccounts] = useState([]);
  const [showNewForm, setShowNewForm] = useState(false);
  const [newLabel, setNewLabel] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newAppPassword, setNewAppPassword] = useState('');
  const [error, setError] = useState('');
  const [sendingId, setSendingId] = useState(null);
  const [statusById, setStatusById] = useState({});

  const load = () => {
    gmailAccountsAPI.getAll().then(res => {
      if (Array.isArray(res.data)) setAccounts(res.data);
    }).catch(() => {});
  };

  useEffect(load, []);

  const handleSave = async () => {
    if (!newLabel.trim() || !newEmail.trim() || !newAppPassword.trim()) return;
    setError('');
    try {
      const res = await gmailAccountsAPI.create(newLabel.trim(), newEmail.trim(), newAppPassword.trim());
      setAccounts(prev => [...prev, res.data]);
      setShowNewForm(false);
      setNewLabel('');
      setNewEmail('');
      setNewAppPassword('');
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось сохранить аккаунт');
    }
  };

  const handleDelete = async (id) => {
    if (!confirm('Удалить этот gmail-аккаунт?')) return;
    try {
      await gmailAccountsAPI.delete(id);
      setAccounts(prev => prev.filter(a => a.id !== id));
    } catch {}
  };

  const handleSend = async (id) => {
    if (sendingId) return;
    setSendingId(id);
    setStatusById(prev => ({ ...prev, [id]: null }));
    try {
      await smsAPI.send(id);
      setStatusById(prev => ({ ...prev, [id]: 'success' }));
    } catch (err) {
      setStatusById(prev => ({ ...prev, [id]: err.response?.data?.error || 'Не удалось отправить SMS' }));
    } finally {
      setSendingId(null);
      setTimeout(() => setStatusById(prev => ({ ...prev, [id]: null })), 5000);
    }
  };

  return (
    <div className="at-overlay" onClick={onClose}>
      <div className="at-panel" onClick={e => e.stopPropagation()}>
        <div className="at-header">
          <div className="at-header-left">
            <Mail size={16} className="at-header-icon" />
            <span className="at-title">Gmail-аккаунты (для SMS)</span>
          </div>
          <div className="at-header-right">
            <button className="at-btn at-btn-run" onClick={() => setShowNewForm(v => !v)}>
              <Plus size={13} /> Добавить аккаунт
            </button>
            <button className="at-btn at-btn-ghost" onClick={onClose} title="Закрыть">
              <X size={15} />
            </button>
          </div>
        </div>

        {error && <div className="vl-run-error">{error}</div>}

        {showNewForm && (
          <div className="vl-new-account-form">
            <input
              placeholder="Название"
              value={newLabel}
              onChange={e => setNewLabel(e.target.value)}
            />
            <input
              placeholder="Gmail-адрес"
              value={newEmail}
              onChange={e => setNewEmail(e.target.value)}
            />
            <input
              placeholder="App password"
              value={newAppPassword}
              onChange={e => setNewAppPassword(e.target.value)}
            />
            <button className="at-btn at-btn-ghost" onClick={handleSave} title="Сохранить">
              <Check size={12} />
            </button>
            <button className="at-btn at-btn-ghost" onClick={() => setShowNewForm(false)} title="Отмена">
              <X size={12} />
            </button>
          </div>
        )}

        <div className="vl-results-list">
          {accounts.length === 0 ? (
            <div className="at-empty">
              <Mail size={28} />
              <p>Аккаунтов нет</p>
              <span>Нажмите «Добавить аккаунт»</span>
            </div>
          ) : (
            accounts.map(a => (
              <div className="vl-row" key={a.id}>
                <span className="vl-row-country">{a.label}</span>
                <span className="vl-row-link">{a.email}</span>
                {statusById[a.id] === 'success' && (
                  <span className="save-success"><Check size={12} /> SMS отправлено</span>
                )}
                {statusById[a.id] && statusById[a.id] !== 'success' && (
                  <span className="save-success" style={{ color: 'var(--danger)', background: 'var(--danger-bg)' }}>
                    <AlertTriangle size={12} /> {statusById[a.id]}
                  </span>
                )}
                <button
                  className="at-btn at-btn-ghost"
                  onClick={() => handleSend(a.id)}
                  disabled={sendingId === a.id}
                  title="Отправить статичное SMS-уведомление на softkuram@gmail.com"
                >
                  <MessageCircle size={12} /> {sendingId === a.id ? 'Отправка...' : 'Отправить SMS'}
                </button>
                <button className="vl-row-copy" onClick={() => handleDelete(a.id)} title="Удалить">
                  <Trash2 size={12} />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default GmailAccounts;
